import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'
import api from '@/request/api.js'
const vuexLocal = new VuexPersistence({
    storage: window.localStorage
})
import product from './settle/product'; // 商家入驻
const Modele = {
  product
}
Vue.use(Vuex)
const store=new Vuex.Store({
   state:{
       userInfo:'',
       linklogin:false,
       regist:{
        reviewer_status:'',
        phone:'',
        statusParams:''
      }, //审核未通过，参数
   },
   getters:{
       getUserInfo(state){
          return state.userInfo;
       },
       getLogin(state){
           return state.linklogin;
       },
       getRegist: state => {
        return state.regist;
      },
       getStatusParams: state => {
        return state.statusParams;
      },
   },
   mutations:{
       setUserInfo(state,data){
           state.userInfo=data;
       },
       setLogin(state,data){
           state.linklogin=data;
       },
       setRegist(state, data) {
        state.regist = data;
      },
       setStatusParams(state, data) {
        state.statusParams = data;
      },
   },
   actions:{
      Login({rootState,commit},data){
           return api.Login(data);
      }  
   },
   modules:{
    ...Modele
   },
   plugins: [vuexLocal.plugin]
})
export default store


// WEBPACK FOOTER //
// ./src/store/index.js